import { render, staticRenderFns } from "./HotkeyHelp.vue?vue&type=template&id=37348ca8&scoped=true"
import script from "./HotkeyHelp.vue?vue&type=script&lang=js"
export * from "./HotkeyHelp.vue?vue&type=script&lang=js"
import style0 from "./HotkeyHelp.vue?vue&type=style&index=0&id=37348ca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37348ca8",
  null
  
)

export default component.exports